// extracted by mini-css-extract-plugin
export var actionButton = "_iy-0";
export var fileInput = "_iy-2";
export var paperclip = "_iy-1";